export const enum CnxIdType {
  Generic = 'generic',
  Random = 'random',
  RandomShort = 'randomshort',
  User = 'user',
  Tenant = 'tenant',
  Company = 'company',
  Location = 'location',
  Vehicle = 'vehicle',
  Fleet = 'fleet',
  TourPlanFleet = 'tourplanfleet',
  Tourplan = 'tourplan',
  Load = 'load',
  Tour = 'tour',
  Stop = 'stop',
  Shipment = 'shipment',
  Shipper = 'shippper',
  Carrier = 'carrier',
  Dispatcher = 'dispatcher',
  Article = 'article',
  Order = 'order',
  OrderPlanning = 'orderplanning',
  OrderPlanningVehicle = 'orderplanningvehicle',
  Packaging = 'packaging',
}

export type CnxIdOptions = {
  alphabet: string;
  size: number;
  prefix?: string;
  time_size?: number;
};
